module.exports = __webpack_public_path__ + "img/Abschnittsleiter_Technik_und_Sicherheit.3a933b29.svg";